import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import loginlogo from "../../Assets/Logo/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import {
  resetPassword,
  sendForgotPasswordOTP,
} from "../../redux/slice/LoginSlice";
import ButtonLoader from "../../components/Common/ButtonLoader";
import ValidationSchema from "../../components/Common/ValidationSchema";
import OTPInput from "react-otp-input";
import { successStatusCode } from "../../utils/constants";
import { toast } from "react-toastify";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const ForgotPassword = () => {
  const [mode, setMode] = useState(1);
  const [otpTime, setOtpTime] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpResponse, setOtpResponse] = useState({});
  const initialValues = {
    email: "",
  };
  const initialPasswordValues = {
    password: "",
    confirmPassword: "",
    otpCode: "",
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (mode === 2) {
      var timer = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          setOtpTime(false);
        }
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [seconds, mode]);

  const { values, errors, handleBlur, handleChange, touched, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: ValidationSchema.forgotPassword,
      onSubmit: async () => {
        sendOTP();
      },
    });

  const {
    values: passwordValues,
    errors: passwordErrors,
    handleBlur: passwordHandleBlur,
    handleChange: passwordHandleChange,
    touched: passwordTouched,
    handleSubmit: passwordHandleSubmit,
    resetForm,
    setValues,
    setTouched,
  } = useFormik({
    initialValues: initialPasswordValues,
    validationSchema: ValidationSchema.resetPassword,
    onSubmit: async () => {
      if (passwordValues.password !== passwordValues.confirmPassword) {
        toast.error("Password do not match with confirm password");
        return;
      } else {
        const payload = {
          user_id: otpResponse?.user_id,
          otp: passwordValues.otpCode,
          password: passwordValues.password,
          confirm_password: passwordValues.confirmPassword,
        };
        setLoading(true);
        const response = await dispatch(resetPassword(payload));
        setLoading(false);
        const result = response?.payload;
        if (result?.status === successStatusCode) {
          navigate("/login");
        }
      }
    },
  });

  const sendOTP = async () => {
    setLoading(true);
    const email = values?.email?.toLowerCase();
    try {
      const response = await dispatch(sendForgotPasswordOTP({ email }));
      const result = response?.payload;
      if (result?.status === successStatusCode) {
        setOtpResponse(result?.data ?? {});
        setMode(2);
        setSeconds(60);
        setOtpTime(true);
      }
    } catch (error) {
      // Handle error
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const resendOTP = () => {
    setValues({
      ...passwordValues,
      otpCode: "",
    });
    setTouched({ ...passwordTouched, otpCode: false });
    sendOTP();
  };

  const handleChangeEmail = () => {
    setMode(1);
    resetForm();
    otpResponse({});
  };

  const handleChangeOTP = (value) => {
    setValues({
      ...passwordValues,
      otpCode: value,
    });
    if (Number(value) === otpResponse?.otp) {
      setSeconds(0);
      setOtpTime(false);
    }
  };

  return (
    <div className="container">
      <div className="row align-items-center full-dynamic-height">
        <div className="col-md-8 mx-auto py-3">
          <div className="loginWrapper  card p-4">
            <figure className="authfigure">
              <img src={loginlogo} alt="loginlogo" />
            </figure>
            {mode === 1 ? (
              <>
                <h4 className="authheading">FORGOT PASSWORD</h4>
                <Form
                  onSubmit={handleSubmit}
                  className="d-flex flex-column row-gap-3"
                >
                  <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter email"
                    />
                    {errors.email && touched.email && (
                      <p className="text-danger mt-1 mb-0">{errors.email} </p>
                    )}
                    <div
                      className="d-flex align-items-center justify-content-end mt-2 gap-1"
                      style={{ fontSize: "14px" }}
                    >
                      Remember your password?
                      <NavLink
                        to="/login"
                        className="float-end"
                        style={{
                          color: "var(--bs-primary)",
                        }}
                      >
                        Login
                      </NavLink>
                    </div>
                  </Form.Group>
                  <div>
                    <Button variant="primary" type="submit" disabled={loading}>
                      {loading ? <ButtonLoader /> : "Reset Password"}
                    </Button>
                  </div>
                </Form>
              </>
            ) : (
              <Form
                onSubmit={passwordHandleSubmit}
                className="d-flex flex-column row-gap-3"
              >
                <h4 className="authheading mb-0">ENTER OTP</h4>
                <div>
                  <OTPInput
                    value={passwordValues.otpCode}
                    inputType="number"
                    numInputs={6}
                    renderInput={(props) => (
                      <input {...props} className="hide-spinner" />
                    )}
                    onChange={handleChangeOTP}
                    inputStyle={{
                      height: "42px",
                      fontSize: "24px",
                      borderRadius: "8px",
                      border: "1px solid rgba(23, 23, 23, 0.5)",
                      outline: "none",
                      textAlign: "center",
                      flex: 1,
                    }}
                    containerStyle={{
                      flexWrap: "wrap",
                      gap: 12,
                      maxWidth: "300px",
                    }}
                  />
                  {passwordErrors.otpCode && passwordTouched.otpCode && (
                    <p className="text-danger mt-1 mb-0">
                      {passwordErrors.otpCode}
                    </p>
                  )}
                </div>
                <div style={{ fontSize: "14px" }}>
                  {otpTime ? (
                    <>
                      <span>Resend in </span>
                      <span>
                        {seconds < 10 ? "0" + seconds : seconds}{" "}
                        {seconds > 1 ? "seconds" : "second"}
                      </span>
                    </>
                  ) : (
                    <div className="d-flex justify-content-between gap-2 flex-wrap">
                      <span className="cursor" onClick={resendOTP}>
                        Resend Code
                      </span>
                      <span className="cursor" onClick={handleChangeEmail}>
                        Change Email
                      </span>
                    </div>
                  )}
                </div>
                <Form.Label className="mb-0 pt-3">Choose password</Form.Label>
                <div>
                  <Form.Group className="d-flex align-items-center">
                    <Form.Control
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={passwordValues.password}
                      onChange={passwordHandleChange}
                      onBlur={passwordHandleBlur}
                      placeholder="Password"
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </button>
                  </Form.Group>
                  {passwordErrors.password && passwordTouched.password && (
                    <p className="text-danger mt-1 mb-0">
                      {passwordErrors.password}
                    </p>
                  )}
                </div>
                <div>
                  <Form.Group className="d-flex align-items-center">
                    <Form.Control
                      name="confirmPassword"
                      type={showConfirmPassword ? "text" : "password"}
                      value={passwordValues.confirmPassword}
                      onChange={passwordHandleChange}
                      onBlur={passwordHandleBlur}
                      placeholder="Confirm Password"
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </button>
                  </Form.Group>
                  {passwordErrors.confirmPassword &&
                    passwordTouched.confirmPassword && (
                      <p className="text-danger mt-1 mb-0">
                        {passwordErrors.confirmPassword}
                      </p>
                    )}
                </div>
                <div>
                  <Button variant="primary" type="submit" disabled={loading}>
                    {loading ? <ButtonLoader /> : "Save"}
                  </Button>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
